module.exports = __webpack_public_path__ + "img/list2.77b5c4ed.png";